import { Injectable } from '@angular/core';
import { HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BafAgentService } from '../../core/services/baf-agent/baf-agent.service';
import { UploadState } from './upload-state';
import { UploadEvent } from './upload-event';

@Injectable()
export class UploadService {
  progress = 0;

  constructor(private bafAgent: BafAgentService) {}

  uploadData(form: FormData): Observable<UploadEvent> {
    const events = new Subject<UploadEvent>();
    this.progress = 0;
    this.bafAgent.uploadData(form).subscribe(
      event => {
        switch (event.type) {
          case HttpEventType.Sent:
            events.next({
              state: UploadState.Started,
              data: null
            });
            break;
          case HttpEventType.UploadProgress:
            this.progress = Math.max(this.progress, Math.round((100 * event.loaded) / event.total));
            events.next({
              state: UploadState.Progress,
              data: this.progress
            });
            break;
          case HttpEventType.Response:
            events.next({
              state: UploadState.Finished,
              data: event.body
            });
            break;
        }
      },
      error => events.error(error)
    );

    return events.asObservable();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/upload/upload.service.ts